import { Button } from './ui/button';

/**
 * Shared 4/4/9 mismatch notice for MANUAL macro targets (onboarding Manual
 * Macros + Settings Macro Targets). `check` is utils/macroConsistency
 * checkManualMacros(). Renders nothing unless the four values disagree. The
 * only fix offered keeps the grams and adopts the derived calorie total, and
 * only when the user taps it — nothing is changed silently.
 */
export default function MacroMismatchNotice({ check, onUseDerived }) {
  if (!check || !check.mismatch) return null;
  return (
    <div
      role="alert"
      data-testid="macro-mismatch"
      className="rounded-xl border border-amber-500/40 bg-amber-500/10 p-4 space-y-3"
    >
      <p className="text-sm text-foreground">
        Your protein, carbs and fat add up to{' '}
        <span className="font-semibold" data-testid="macro-derived-calories">{check.expectedCalories}</span>{' '}
        calories (protein×4 + carbs×4 + fat×9), but you entered{' '}
        <span className="font-semibold">{check.calories}</span>.
      </p>
      <Button
        type="button"
        variant="outline"
        onClick={onUseDerived}
        data-testid="use-derived-calories-btn"
        className="w-full h-10 rounded-full"
      >
        {`Use ${check.expectedCalories} calories`}
      </Button>
      <p className="text-xs text-muted-foreground">Or adjust your protein, carbs or fat.</p>
    </div>
  );
}
